import { useEffect } from 'react';
import { useSettings } from '../context/SettingsContext';

const GoogleTagManager = () => {
    const { settings } = useSettings();
    const gtmId = settings?.gtm_id;

    useEffect(() => {
        if (!gtmId || gtmId.trim() === '') {
            return; // Don't load GTM if no ID is set
        }

        // Check if GTM is already loaded
        if (window.dataLayer) {
            return;
        }

        // Load GTM script
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer',gtmId);

        console.log(`Google Tag Manager loaded with ID: ${gtmId}`);
    }, [gtmId]);

    // Render noscript fallback
    if (!gtmId || gtmId.trim() === '') {
        return null;
    }

    return (
        <noscript>
            <iframe
                src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
                height="0"
                width="0"
                style={{ display: 'none', visibility: 'hidden' }}
                title="Google Tag Manager"
            />
        </noscript>
    );
};

export default GoogleTagManager;
